<template>
  <div>
    <SectionOne v-if="current===0" :projectId="projectId" />
    <SectionTwo v-if="current===1" :projectId="projectId" />
    <SectionThree v-if="current===2" :projectId="projectId" />
    <div class="steps-action action-container action-container__bottom">
      <a-button :disabled="current <=0" class="action-btn first-action-btn" @click="current = current - 1">
        查看上一部分
      </a-button>
      <a-button :disabled="current >=2"  class="action-btn" @click="current = current + 1">
        查看下一部分
      </a-button>
    </div>
  </div>
</template>
<script>
import SectionOne from "@/views/SectionOne.vue";
import SectionTwo from "@/views/SectionTwo.vue";
import SectionThree from "@/views/SectionThree.vue";

export default {
  components: { SectionOne, SectionTwo, SectionThree },
  data() {
    return {
      projectId: "",
      current: 0,
    };
  },
  created() {
    this.projectId = this.$route.params.id;
    console.log('view doc, projectId', this.projectId);
  },
  methods: {

  }
}
</script>
<style scoped>

</style>
